import axios from 'axios';
import { FileText, FileSpreadsheet, Presentation, Image, Video, Link2, FileArchive, Music, File } from 'lucide-react';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const authHeader = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

export const MAX_SIZE = 100 * 1024 * 1024;
export const ALLOWED_EXT = ['pdf', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx', 'csv', 'txt', 'png', 'jpg', 'jpeg', 'gif', 'webp', 'mp4', 'mov', 'webm', 'mp3', 'zip'];
export const ACCEPT = ALLOWED_EXT.map((e) => `.${e}`).join(',');

export const CATEGORY_CONFIG = {
  general: { label: 'General', cls: 'bg-gray-500/10 text-gray-400 border-gray-500/20' },
  sop: { label: 'SOP', cls: 'bg-blue-500/10 text-blue-400 border-blue-500/20' },
  template: { label: 'Template', cls: 'bg-purple-500/10 text-purple-400 border-purple-500/20' },
  guide: { label: 'Guide', cls: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20' },
  tool: { label: 'Tool', cls: 'bg-amber-500/10 text-amber-400 border-amber-500/20' },
};

const tone = (icon, label, cls) => ({ icon, label, cls });
const WORD = tone(FileText, 'WORD', 'text-sky-400 bg-sky-500/10 border-sky-500/25');
const SLIDES = tone(Presentation, 'SLIDES', 'text-orange-400 bg-orange-500/10 border-orange-500/25');
const SHEET = tone(FileSpreadsheet, 'SHEET', 'text-emerald-400 bg-emerald-500/10 border-emerald-500/25');
const IMAGE = tone(Image, 'IMAGE', 'text-fuchsia-400 bg-fuchsia-500/10 border-fuchsia-500/25');
const VIDEO = tone(Video, 'VIDEO', 'text-pink-400 bg-pink-500/10 border-pink-500/25');
const VISUALS = {
  pdf: tone(FileText, 'PDF', 'text-red-400 bg-red-500/10 border-red-500/25'),
  doc: WORD, docx: WORD, ppt: SLIDES, pptx: SLIDES, xls: SHEET, xlsx: SHEET, csv: SHEET,
  png: IMAGE, jpg: IMAGE, jpeg: IMAGE, gif: IMAGE, webp: IMAGE, mp4: VIDEO, mov: VIDEO, webm: VIDEO,
  mp3: tone(Music, 'AUDIO', 'text-violet-400 bg-violet-500/10 border-violet-500/25'),
  zip: tone(FileArchive, 'ZIP', 'text-amber-400 bg-amber-500/10 border-amber-500/25'),
  txt: tone(File, 'TEXT', 'text-gray-300 bg-gray-500/10 border-gray-500/25'),
};
const LINK = tone(Link2, 'LINK', 'text-cyan-400 bg-cyan-500/10 border-cyan-500/25');

export const itemVisual = (item) => (item.kind === 'file' ? VISUALS[item.ext] || VISUALS.txt : LINK);

export const previewKind = (item) => {
  if (item.kind !== 'file') return null;
  if (item.ext === 'pdf') return 'pdf';
  if (['png', 'jpg', 'jpeg', 'gif', 'webp'].includes(item.ext)) return 'image';
  if (['mp4', 'webm', 'mov'].includes(item.ext)) return 'video';
  return null;
};

export const fileAccessUrl = async (item, download = false) => {
  const res = await axios.get(`${API}/library/items/${item.id}/access`, authHeader());
  return `${API}/library/items/${item.id}/file?t=${encodeURIComponent(res.data.token)}${download ? '&download=1' : ''}`;
};

export const downloadItem = async (item) => {
  const a = document.createElement('a');
  a.href = await fileAccessUrl(item, true);
  a.download = item.original_filename || '';
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export const formatSize = (bytes = 0) => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
};

export const formatDate = (iso) => (iso ? new Date(iso).toLocaleDateString('en-MY', { day: '2-digit', month: 'short', year: 'numeric' }) : '');

export const linkHost = (url = '') => {
  try { return new URL(url).hostname.replace(/^www\./, ''); } catch { return url; }
};
